const roundWithDecimal = (value: number, decimalPoints: number = 0) => {
    return (
      Math.round(value * Math.pow(10, decimalPoints)) /
      Math.pow(10, decimalPoints)
    );
  };
  
  export default roundWithDecimal;
  